

export const mapLeadershipApiItem = (item) => ({
  id: item.attentionId || String(Math.random()),
  description: item.description || "-",
  remarks: item.remarks || "-",
  status: item.status || "Open",
  openedOn: item.openedOn || item.updatedAt || null,
  closedOn: item.closedOn || null,
  deleted: Boolean(item.deleted),
});

export const formatLeadershipDate = (value) => {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "-";

  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const dd = String(date.getDate()).padStart(2, "0");
  const yyyy = date.getFullYear();

  return `${mm}-${dd}-${yyyy}`;
};

export const getLeadershipStatusColor = (status) => {
  const normalized = (status || "").trim().toLowerCase();
  if (normalized === "closed" || normalized === "resolved") return "green";
  return "gold";
};
